import React from "react";
import "./Proceed_to_Checkout.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import CheckoutStepForm from "./checkoutStepForm/CheckoutStepForm";

function Proceed_to_Checkout() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Cart Product", link: "/product-cart", isActive: false },
    { label: "Personal Details", link: "", isActive: true },
  ];
  return (
    <>
      <section className="Proceed_to_Checkout">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <div className="Proceed_to_Checkout_step_form_holder">
          <div className="container-fluid">
            <CheckoutStepForm />
          </div>
        </div>

        {/* <Stay_Connected /> */}
      </section>
    </>
  );
}

export default Proceed_to_Checkout;
